module.exports = __webpack_public_path__ + "img/Slider-IMMO_es.9104fab2.png";